import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError } from "rxjs/operators";

@Component({
  selector: "app-validate",
  templateUrl: "./validate.component.html",
  styleUrls: ["./validate.component.css"],
})
export class ValidateComponent implements OnInit {
  tokenValue: any = "";
  verifyResponse: any = "";
  isTokenError: boolean = false;
  inValidToken: boolean = true;
  isEmpty: boolean = false;

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";
  accesstoken: any = "";

  constructor(
    private _restService: RestService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.tokenValue = this.route.snapshot.paramMap.get("token");
    console.log(this.tokenValue);
    this._restService
      .verifyEmailAddress(this.tokenValue)
      .pipe(
        catchError((e) => {
          console.log("err --->", e);
          this.isFailure = true;
          this.failureMessage = e.error.StatusInfo;
          return e;
        })
      )
      .subscribe(
        (response) => (
          (this.verifyResponse = response),
          console.log("Response --->>", response)
        )
      );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
    this.router.navigate([""]), (this.isTokenError = false);
  }

  removingBlankSpace(e: any) {
    this.isTokenError = false;
    this.isEmpty = false;
    e.target.value.substring(0, 1) === " "
      ? (e.target.value = "")
      : (this.accesstoken = e.target.value);
  }

  //Verifying valid/invalid user
  verifyUserAuthPermission(userid: any, admin: any, token: any, pwd: any) {
    console.log(userid + "---" + admin + "---" + token + "---" + pwd);

    token === "" || token === undefined
      ? (this.isEmpty = true)
      : ((this.isEmpty = false),
        this._restService
          .verifyingUserByToken(userid, admin, token, pwd)
          .pipe(
            catchError((e) => {
              console.log("err --->", e);
              this.isFailure = true;
              this.failureMessage = e.error.StatusInfo;
              return e;
            })
          )
          .subscribe(
            (response: any) => (
              (this.isSuccess = true),
              (this.successMessage = "Verified Successfully. You can login now")
            )
          ));
  }
}
